import React from 'react';
import { Chart } from 'react-google-charts';
import { rupiah } from 'utils/formatter';
import ChartLoadingSpinner from './ChartLoadingSpinner';
import styles from './style.css';

const DAY_OF_WEEK_SALES_CHART_OPTIONS = {
  title: '',
  isStacked: true,
  fill: 20,
  displayExactValues: true,
  vAxis: { title: '', gridlines: { count: 10, color: 'transparent' } },
  legend: { position: 'none' },
  hAxis: { title: '' },
  colors: ['#3498DB', '#3498DB'],
  areaOpacity: 1.0,
};

function generateChartData(weeklyGrossSales) {
  const result = [];

  // PUSH HEADER
  result.push([{ role: 'domain' }, 'Gross Sales']);
  weeklyGrossSales.forEach(transactionDayOfWeek => {
    result.push([
      transactionDayOfWeek.dayOfWeek,
      {
        v: transactionDayOfWeek.sumGrossSales,
        f: `${rupiah(transactionDayOfWeek.sumGrossSales)} \n Num Sales: ${
          transactionDayOfWeek.numSales
        }`,
      },
    ]);
  });
  return result;
}

function DayOfWeekSalesChart(props) {
  const { weeklyGrossSales, renderCounter } = props;
  const chartData = generateChartData(weeklyGrossSales);

  return (
    <div className={styles['sales-chart-box']}>
      <div className={styles['title-chart-left']}>
        DAY OF THE WEEK GROSS SALES AMOUNT
      </div>
      <div className="my-pretty-chart-container">
        <Chart
          chartType="ColumnChart"
          data={chartData}
          options={DAY_OF_WEEK_SALES_CHART_OPTIONS}
          graph_id={`area-chart-week-${renderCounter}`}
          width="100%"
          height="200px"
          legend_toggle
          loader={<ChartLoadingSpinner />}
        />
      </div>
    </div>
  );
}

export default DayOfWeekSalesChart;
